"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinTradeSize = void 0;
const _1 = require(".");
const common_sdk_1 = require("@orca-so/common-sdk");
const getMinTradeSize = (minTradeSize) => {
    const mulipliedTradesize = minTradeSize.mul(_1.DENOMINATOR);
    return common_sdk_1.DecimalUtil.toU64(mulipliedTradesize);
};
exports.getMinTradeSize = getMinTradeSize;
